var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "55", height: "55", viewBox: "0 0 55 55", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Group 2"
    ),
    React.createElement(
      "g",
      { transform: "translate(2 2)", stroke: "#FFF", strokeWidth: "3", fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { cx: "25.5", cy: "25.5", r: "25.5" }),
      React.createElement("path", { fill: "#FFF", d: "M38.5 25l-20 13.5v-27z" })
    )
  );
});